import { Platform } from 'react-native';
import { BORDER_RADIUS } from '@/constants/config';

export function withAlpha(color, alpha) {
  if (!color || typeof color !== 'string') return `rgba(0, 0, 0, ${alpha})`;
  const rgb = color.match(/rgba?\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)/i);
  if (rgb) return `rgba(${rgb[1]}, ${rgb[2]}, ${rgb[3]}, ${alpha})`;
  const hex = color.replace('#', '');
  const full = hex.length === 3 ? hex.split('').map((c) => c + c).join('') : hex;
  if (full.length !== 6) return color;
  const r = parseInt(full.slice(0, 2), 16);
  const g = parseInt(full.slice(2, 4), 16);
  const b = parseInt(full.slice(4, 6), 16);
  if ([r, g, b].some((n) => Number.isNaN(n))) return color;
  return `rgba(${r}, ${g}, ${b}, ${alpha})`;
}

export function bannerCardShadow(isDark) {
  return Platform.select({
    web: {
      boxShadow: isDark
        ? '0 8px 28px rgba(0, 0, 0, 0.45), 0 0 0 1px rgba(255, 255, 255, 0.04)'
        : '0 10px 32px rgba(15, 23, 42, 0.10), 0 2px 6px rgba(15, 23, 42, 0.04)',
      backdropFilter: 'blur(16px)',
      WebkitBackdropFilter: 'blur(16px)',
    },
    ios: {
      shadowColor: '#000',
      shadowOffset: { width: 0, height: 8 },
      shadowOpacity: isDark ? 0.35 : 0.12,
      shadowRadius: 20,
    },
    android: {
      elevation: 6,
    },
    default: {},
  });
}

export function bannerSurface(colors, isDark, accent) {
  return {
    backgroundColor: colors.solid_color_block,
    borderWidth: 1,
    borderColor: colors.border_color_secondary,
    borderRadius: BORDER_RADIUS.medium,
    overflow: 'hidden',
    ...bannerCardShadow(isDark),
    ...(Platform.OS === 'web' && accent
      ? {
          backgroundImage: `linear-gradient(105deg, ${withAlpha(accent, isDark ? 0.16 : 0.08)} 0%, transparent 48%)`,
        }
      : {}),
  };
}

export function bannerFallbackIcon(contentType) {
  switch (contentType) {
    case 'promo-code':
      return 'gift';
    case 'announcement':
      return 'bullhorn';
    case 'link':
      return 'arrow-up-right';
    default:
      return 'sparkles';
  }
}

export const webInteractive = Platform.OS === 'web'
  ? { cursor: 'pointer', transition: 'background-color 0.15s, border-color 0.15s, opacity 0.15s' }
  : {};
